module.exports = __webpack_public_path__ + "static/media/pm.63e160a1.svg";